import { TableHeaderCategoryConfig } from "../../../../components/tables/tableContext/TableContext";

import { MonthlyActivityWmsDataInterface } from "../../../../redux/interfaces/reports.interface"; // Presupunând că această interfață va fi actualizată sau extinsă pentru a include noile câmpuri.

export const monthlyActivityTableHeader: TableHeaderCategoryConfig[] = [
  {
    label: "Username",
    value: "userName",
    minW: 125,
  },
  {
    label: "Prenume",
    value: "prenume",
    minW: 125,
  },
  {
    label: "Nume",
    value: "nume",
    minW: 125,
  },
  {
    label: "Taskuri Putaway",
    value: "putAway",
    minW: 125,
  },
  {
    label: "Produse Putaway",
    value: "putAwayNrProduse",
    minW: 125,
  },
  {
    label: "Taskuri Rearanjare",
    value: "rearanjare",
    minW: 125,
  },
  {
    label: "Produse Rearanjare",
    value: "rearanjareNrProduse",
    minW: 125,
  },
  {
    label: "Taskuri Umplere",
    value: "umplere",
    minW: 125,
  },
  {
    label: "Produse Umplere",
    value: "umplereNrProduse",
    minW: 125,
  },
  {
    label: "Comenzi Colectate",
    value: "comenziColectate",
    minW: 125,
  },
  {
    label: "Poziții Colectate",
    value: "comenziColectateNrPozitii",
    minW: 125,
  },
  {
    label: "Produse Colectate",
    value: "comenziColectateNrProduse",
    minW: 125,
  },
  {
    label: "Comenzi Verificate",
    value: "comenziVerificate",
    minW: 125,
  },
  {
    label: "Poziții Verificate",
    value: "comenziVerificateNrPozitii",
    minW: 125,
  },
  {
    label: "Produse Verificate",
    value: "comenziVerificateNrProduse",
    minW: 125,
  },
  {
    label: "Recepții Deschise",
    value: "receptiiDeschise",
    minW: 125,
  },
  {
    label: "Produse Recepționate",
    value: "produseReceptionate",
    minW: 125,
  },
  {
    label: "Produse Soluționate",
    value: "produseSolutionate",
    minW: 125,
  },
  {
    label: "Cutii Scanate Exp.",
    value: "NrCutiiScanateExpeditie",
    minW: 125,
  },
  {
    label: "Cantitate Minus",
    value: "CantitateMinus",
    minW: 125,
  },
  {
    label: "Cantitate Plus",
    value: "CantitatePlus",
    minW: 125,
  },
  {
    label: "Lot BBD",
    value: "lotBBD",
    minW: 125,
  },
];

export const getMonthlyActivityTableData = (
  reportsUserActivityList: MonthlyActivityWmsDataInterface[],
) =>
  reportsUserActivityList?.map((item) => {
    return {
      id: item.idUser,
      crudData: item,
      data: [
        {
          title: item.userName,
        },
        {
          title: item.prenume,
        },
        {
          title: item.nume,
        },
        {
          title: item.putAway ?? "-",
        },
        {
          title: item.putAwayNrProduse ?? "-",
        },
        {
          title: item.rearanjare ?? "-",
        },
        {
          title: item.rearanjareNrProduse ?? "-",
        },
        {
          title: item.umplere ?? "-",
        },
        {
          title: item.umplereNrProduse ?? "-",
        },
        {
          title: item.comenziColectate ?? "-",
        },
        {
          title: item.comenziColectateNrPozitii ?? "-",
        },
        {
          title: item.comenziColectateNrProduse ?? "-",
        },
        {
          title: item.comenziVerificate ?? "-",
        },
        {
          title: item.comenziVerificateNrPozitii ?? "-",
        },
        {
          title: item.comenziVerificateNrProduse ?? "-",
        },
        {
          title: item.receptiiDeschise ?? "-",
        },
        {
          title: item.produseReceptionate ?? "-",
        },
        {
          title: item.produseSolutionate ?? "-",
        },
        {
          title: item.NrCutiiScanateExpeditie ?? "-",
        },
        {
          title: item.CantitateMinus ?? "-",
        },
        {
          title: item.CantitatePlus ?? "-",
        },
        {
          title: item.lotBBD ?? "-",
        },
      ],
    };
  });
